/** Plain-language lines for the run page: what each step does, and what a long-running step is doing now. Pure. */
import type { TemplateName } from './schemas'

/** Steps that mean the same in every template that has them. */
const SHARED: Record<string, string> = {
  tags: 'labelling the computer so we can find it',
  firewall: 'closing every door except our own',
  box: 'renting the computer',
  boxActive: 'waiting for the computer to switch on',
  repoFromStarter: 'copying the starter app into a new repo',
  railwayProject: 'making a home for the app',
  railwayService: 'connecting the repo so each push builds',
  appToken: 'giving your app its own key to cpg.computer',
  railwayDomain: 'giving the app a temporary address',
  deploy: 'building your app and starting it',
  customDomain: 'asking for your own address',
  dns: 'pointing your address at the app',
  https: 'issuing the certificate for your address',
  kindeCallbacks: 'letting your address use sign-in',
  previewTunnel: 'setting up your private preview address',
  agentOnline: 'waiting for your computer to finish setting up',
  cloneRepo: 'putting your app\'s code on your computer',
  previewOn: 'switching on your preview',
  attachRepo: 'checking we can reach your repo',
  attachDeploy: 'checking we can reach where your app runs',
  person: 'adding them to the list',
  linuxUser: "giving them an account on the computer: the founder's, or a clean one of their own",
  paseoDaemon: 'checking Paseo runs for them on the computer',
  personClone: 'copying the code into their own account',
  kindeInvite: 'adding them to the sign-in list',
  pairingLink: 'checking their pairing link works',
}

/** Teardown reuses some keys (dns, box) for the opposite job. */
const BY_TEMPLATE: Partial<Record<TemplateName, Record<string, string>>> = {
  teardown: {
    dns: 'removing the address records',
    railwayProject: 'shutting the app down',
    repo: 'deleting the repo we made',
    box: 'returning the computer',
    firewall: 'removing its firewall',
    tags: 'removing its label',
    kindeCallbacks: 'removing its sign-in addresses',
    preview: 'removing the preview address',
  },
}

export function stepDescription(template: TemplateName, key: string): string | null {
  return BY_TEMPLATE[template]?.[key] ?? SHARED[key] ?? null
}

/** Shown while a step runs, when the wait has a name worth giving. */
const RUNNING: Record<string, string> = {
  https: 'Issuing certificate…',
  agentOnline: 'Installing tools on your computer…',
  cloneRepo: 'Copying your app to your computer…',
  linuxUser: 'Making their account on the computer…',
  personClone: 'Copying the code into their account…',
}

export function runningLabel(template: TemplateName, key: string): string | null {
  return template === 'teardown' ? null : (RUNNING[key] ?? null)
}
